import Vue from 'vue';

export default {
  namespaced: true,

  state: {
    preregistro: null,
    estudios: [],
    referencias: [],
  },

  mutations: {
    SET_PREREGISTRO(state, payload) {
      Vue.set(state, 'preregistro', payload);
    },

    SET_ESTUDIOS(state, payload) {
      Vue.set(state, 'estudios', payload);
    },

    SET_REFERENCIAS(state, payload) {
      Vue.set(state, 'referencias', payload);
    },
  },
};
